const topics = [
  { label: '顶流塌房', hot: true, views: '1.2亿' },
  { label: '综艺翻车', hot: true, views: '9800万' },
  { label: '恋情曝光', hot: true, views: '7600万' },
  { label: '网红黑料', hot: false, views: '6200万' },
  { label: '剧组路透', hot: false, views: '5400万' },
  { label: '红毯翻车', hot: true, views: '4800万' },
  { label: '代孕风波', hot: false, views: '4100万' },
  { label: '偷税漏税', hot: true, views: '3900万' },
  { label: '整容对比', hot: false, views: '3500万' },
  { label: '直播翻车', hot: false, views: '3100万' },
  { label: '私生饭事件', hot: true, views: '2800万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">热门话题</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">全网吃瓜群众正在热议的话题，点击查看详情</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer"
              style={{
                backgroundColor: topic.hot ? 'oklch(var(--primary-50))' : 'oklch(var(--background-50))',
                borderColor: topic.hot ? 'oklch(var(--primary-200))' : 'oklch(var(--background-300))',
              }}
            >
              {topic.hot && <i className="ri-fire-fill text-primary-500 text-xs"></i>}
              <span
                className="text-sm font-medium whitespace-nowrap"
                style={{ color: topic.hot ? 'oklch(var(--primary-700))' : 'oklch(var(--foreground-700))' }}
              >
                #{topic.label}
              </span>
              <span className="text-xs text-foreground-400">{topic.views}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}